import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import ReCAPTCHA from 'react-recaptcha';
import '../../main.css';

function RegisterUser() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [captchaResponse, setCaptchaResponse] = useState('');

  const navigate = useNavigate();

  const handleCaptchaChange = (value) => {
    setCaptchaResponse(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !email || !password || !confirmPassword) {
      setError('لطفا تمام فیلدها را پر کنید.');
      return;
    }
    if (password !== confirmPassword) {
      setError('رمزهای عبور یکسان نیستند.');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('آدرس ایمیل نامعتبر است.');
      return;
    }

    try {
      const response = await fetch('https://api.raynogroup.com/api/registerUser', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, email, password, captcha: captchaResponse }),
      });

      if (!response.ok) {
        throw new Error('خطا در ثبت‌نام. لطفا مجددا تلاش کنید.');
      }

      const data = await response.json();
      setError('');
      navigate('/Login');
      alert('ثبت‌نام با موفقیت انجام شد! لطفا ایمیل خود را برای فعال‌سازی حساب بررسی کنید.');
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="container mt-5 mb-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow">
            <div className="card-body">
              <h5 className="text-center">ثبت‌نام کاربر جدید</h5>
              <form className='form-group my-3' onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="username">نام کاربری:</label>
                  <input
                    className="form-control"
                    type="text"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">ایمیل:</label>
                  <input
                    className="form-control"
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password">رمز عبور:</label>
                  <input
                    className="form-control"
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="confirmPassword">تایید رمز عبور:</label>
                  <input
                    className="form-control"
                    type="password"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                
                <h6>من ربات نیستم</h6>
                <ReCAPTCHA
                  sitekey="6Ld18k8qAAAAABJcJhAd4hz5gE0w1i2KETFaJ9yT"
                  onChange={handleCaptchaChange} />

                <div className="form-group py-3">
                  <button className="btn btn-primary shadow w-100" type="submit">ثبت‌نام</button>
                  {error && <div className="alert alert-danger mt-2">{error}</div>}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterUser;
